import 'rxjs/add/operator/map';

import {
	HttpClient,
	HttpEvent,
	HttpHandler,
	HttpInterceptor,
	HttpRequest,
	HttpResponse,
	HttpErrorResponse
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { Configuracion } from './app.configuracion';
import 'rxjs/add/operator/do';
import { Router } from '@angular/router';
import { UsuarioDTO } from './models/UsuarioDTO';
import { NotifyComponent } from './shared/notify/notify.component';

@Injectable()
export class CoreApiService {
	private actionUrl: string;

	constructor(private http: HttpClient, private _configuracion: Configuracion) {
		this.actionUrl = _configuracion.ServerWithApiUrl;
	}

	public traerTodos<T>(url: string): Observable<T> {
		return this.http.get<T>(this.actionUrl + url);
	}

	public traerPorId<T>(id: number, url: string): Observable<T> {
		return this.http.get<T>(this.actionUrl + url + id);
	}

	public crear<T>(itemName: any, url: string): Observable<T> {
		const toAdd = itemName;
		return this.http.post<T>(this.actionUrl + url, toAdd);
	}

	public actualizar<T>(id: number, itemToUpdate: any, url: string): Observable<T> {
		return this.http.put<T>(this.actionUrl + url + id, JSON.stringify(itemToUpdate));
	}

	public borrar<T>(id: number, url: string): Observable<T> {
		return this.http.delete<T>(this.actionUrl + url + id);
	}
}

@Injectable()
export class AuthService {
	private UsuarioDto: UsuarioDTO = new UsuarioDTO();

	getToken(): string {
		if (sessionStorage.getItem('usuario') != null) {
			this.UsuarioDto = JSON.parse(sessionStorage.getItem('usuario'));
			return this.UsuarioDto.token;
		} else {
			return null;
		}
	}

	getUsuario(): string {
		if (sessionStorage.getItem('usuario') != null) {
			this.UsuarioDto = JSON.parse(sessionStorage.getItem('usuario'));
			return this.UsuarioDto.USUARIO;
		} else {
			return null;
		}
	}
}

@Injectable()
export class Interceptor implements HttpInterceptor {
	constructor(public authService: AuthService, public _router: Router, public _notificador: NotifyComponent) {}

	intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
		if (!req.headers.has('Content-Type')) {
			req = req.clone({ headers: req.headers.set('Content-Type', 'application/json') });
		}

		const token = this.authService.getToken();
		const usuario = this.authService.getUsuario();
		if (token != null) {
			req = req.clone({ headers: req.headers.set('Authorization', token) });
			req = req.clone({ headers: req.headers.set('idUsuario', usuario) });
		}
		req = req.clone({ headers: req.headers.set('Accept', 'application/json') });

		return next.handle(req).do(
			(event: HttpEvent<any>) => {
				if (event instanceof HttpResponse) {
				}
			},
			(err: any) => {
				if (err instanceof HttpErrorResponse) {
					if (err.status === 401) {
						this._router.navigate([ 'auth/login' ]);
					}
				}
			}
		);
	}
}
